import { SHOW_SQUAD_MODAL, HIDE_SQUAD_MODAL } from '../actions/squad';

export const squadModal = (state = null, action) => {
  const { type, squad } = action;
  if (type === SHOW_SQUAD_MODAL) {
    return squad;
  }
  if (type === HIDE_SQUAD_MODAL) {
    return null;
  }

  return state;
};



// WEBPACK FOOTER //
// ./src/reducers/squad.js